import React from "react";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";

const SkeletonCard = () => (
    <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl animate-pulse">
        <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
            <div className="h-4 bg-gray-300 rounded mb-0 sm:mb-2 mr-2 sm:mr-0 w-20"></div>
            <div className="h-6 bg-gray-300 rounded w-12"></div>
        </div>
    </div>
);

const SkeletonSection = () => (
    <section className="bg-white rounded-2xl shadow-sm overflow-hidden mb-4 sm:mb-6">
        <div className="p-4 sm:p-6 border-b border-gray-100">
            <div className="h-6 bg-gray-300 rounded w-32 animate-pulse"></div>
        </div>
        <div className="p-3 sm:p-4 md:p-6">
            <div className="space-y-4 sm:space-y-6">
                <div>
                    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                        <SkeletonCard />
                        <SkeletonCard />
                        <SkeletonCard />
                        <SkeletonCard />
                        <SkeletonCard />
                        <SkeletonCard />
                    </div>
                </div>
            </div>
        </div>
    </section>
);

const IndexComponent = (props: any) => {
    const { castingSummary, isLoading } = props;

    console.log("IndexComponent 렌더링:", { castingSummary, isLoading });

    return (
        <main className="bg-gray-50 min-h-screen">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-6">
                {/* 제목 */}
                <h2 className="text-3xl font-bold text-gray-900 mb-8">
                    {getLanguageValue(PAGE_TYPE.AGENCY, "castingSummary.txtTitle")}
                </h2>

                {isLoading ? (
                    /* 캐스팅 현황 섹션 스켈레톤 */
                    <SkeletonSection />
                ) : (
                    <div className="space-y-6">
                        {/* 캐스팅 현황 섹션 */}
                        <section className="bg-white rounded-2xl shadow-sm overflow-hidden mb-4 sm:mb-6">
                            <div className="p-3 sm:p-4 md:p-6">
                                <div className="space-y-4 sm:space-y-6">
                                    <div>
                                        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                                            {/* 총 요청 수 */}
                                            <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl hover:bg-gray-100 transition-all duration-200 transform hover:-translate-y-1 shadow-sm hover:shadow">
                                                <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
                                                    <h3 className="text-xs sm:text-sm font-medium text-gray-500 mb-0 sm:mb-2 mr-2 sm:mr-0">
                                                        {getLanguageValue(PAGE_TYPE.AGENCY, "castingSummary.txtCastingSectionTotalRequest")}
                                                    </h3>
                                                    <p className="text-lg sm:text-xl lg:text-2xl font-bold text-[#CF3688]">
                                                        {castingSummary?.totalRequestCount || 0}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* 대기중인 채팅 */}
                                            <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl hover:bg-gray-100 transition-all duration-200 transform hover:-translate-y-1 shadow-sm hover:shadow">
                                                <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
                                                    <h3 className="text-xs sm:text-sm font-medium text-gray-500 mb-0 sm:mb-2 mr-2 sm:mr-0">
                                                        {getLanguageValue(PAGE_TYPE.AGENCY, "castingSummary.txtCastingSectionWaitingRequest")}
                                                    </h3>
                                                    <p className="text-lg sm:text-xl lg:text-2xl font-bold text-[#CF3688]">
                                                        {castingSummary?.waitingChattingCount || 0}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* 진행중인 채팅 */}
                                            <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl hover:bg-gray-100 transition-all duration-200 transform hover:-translate-y-1 shadow-sm hover:shadow">
                                                <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
                                                    <h3 className="text-xs sm:text-sm font-medium text-gray-500 mb-0 sm:mb-2 mr-2 sm:mr-0">
                                                        {getLanguageValue(PAGE_TYPE.AGENCY, "castingSummary.txtCastingSectionChatting")}
                                                    </h3>
                                                    <p className="text-lg sm:text-xl lg:text-2xl font-bold text-[#CF3688]">
                                                        {castingSummary?.onChattingCount || 0}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* 종료된 채팅 */}
                                            <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl hover:bg-gray-100 transition-all duration-200 transform hover:-translate-y-1 shadow-sm hover:shadow">
                                                <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
                                                    <h3 className="text-xs sm:text-sm font-medium text-gray-500 mb-0 sm:mb-2 mr-2 sm:mr-0">
                                                        {getLanguageValue(PAGE_TYPE.AGENCY, "castingSummary.txtCastingSectionClosedChat")}
                                                    </h3>
                                                    <p className="text-lg sm:text-xl lg:text-2xl font-bold text-[#CF3688]">
                                                        {castingSummary?.closedChattingCount || 0}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* 취소된 요청 */}
                                            <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl hover:bg-gray-100 transition-all duration-200 transform hover:-translate-y-1 shadow-sm hover:shadow">
                                                <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
                                                    <h3 className="text-xs sm:text-sm font-medium text-gray-500 mb-0 sm:mb-2 mr-2 sm:mr-0">
                                                        {getLanguageValue(PAGE_TYPE.AGENCY, "castingSummary.txtCastingSectionCanceledRequest")}
                                                    </h3>
                                                    <p className="text-lg sm:text-xl lg:text-2xl font-bold text-[#CF3688]">
                                                        {castingSummary?.canceledChattingCount || 0}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* 거절한 요청 */}
                                            <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl hover:bg-gray-100 transition-all duration-200 transform hover:-translate-y-1 shadow-sm hover:shadow">
                                                <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
                                                    <h3 className="text-xs sm:text-sm font-medium text-gray-500 mb-0 sm:mb-2 mr-2 sm:mr-0">
                                                        {getLanguageValue(PAGE_TYPE.AGENCY, "castingSummary.txtCastingSectionDeniedRequest")}
                                                    </h3>
                                                    <p className="text-lg sm:text-xl lg:text-2xl font-bold text-[#CF3688]">
                                                        {castingSummary?.deniedChattingCount || 0}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                )}
            </div>
        </main>
    );
};

export default IndexComponent;
